import React, { useContext, useMemo, useState } from 'react'
import { Button } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { QuestionContainer } from '../../components/Question'
import { useStep } from '../../hooks'
import { Paths } from '../../routes/paths'
import { GbsStore } from '../../store'
import { Actions } from '../../store/actions'
import { useStepData } from '../../store/selectors'
import RangeSlider from 'react-bootstrap-range-slider'

const stepKey = 'recommendedPlans'

export const AverageEmployeeAge = () => {
  const history = useHistory()
  const { dispatch } = useContext(GbsStore)

  const stepData = useStepData(stepKey)

  const stepConfig = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 10,
        backCallback: () => {
          history.push(Paths.totalAmountDependent)
        }
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [history])

  useStep(stepKey, stepConfig, dispatch)

  const [value, setValue] = useState(stepData?.avgAge || 35)

  const onContinue = () => {
    dispatch({
      type: Actions.SetStepData,
      payload: { stepKey, stepData: { avgAge: value } }
    })
    history.push(Paths.recommendedPlans)
  }

  const isDisabled = !value

  return (
    <QuestionContainer>
      <div style={{ width: '60%', margin: '0 auto' }}>
        <h1 className="text-center" style={{ fontFamily: 'Sentinel' }}>
          What is the average age of your employees
          <span className="text-primary">?</span>
        </h1>
        <RangeSlider
          className="mt-5"
          min={18}
          max={75}
          tooltip="on"
          tooltipPlacement="bottom"
          value={value}
          variant="primary"
          tooltipLabel={(currentValue) => `${currentValue}`}
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="d-flex justify-content-between">
          <p className="text-muted">18</p>
          <p className="text-muted">75</p>
        </div>
      </div>
      <div className="text-center mt-5">
        <Button
          style={{ width: 130 }}
          variant="primary"
          onClick={onContinue}
          disabled={isDisabled}
        >
          Next
        </Button>
      </div>
    </QuestionContainer>
  )
}
